import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../services/API';
import historico from '../../../services/Historico';

export default function UploadProduto() {
  const [enviando, setEnviando] = useState(false);
  const [arquivo, setArquivo] = useState(null);
  const [status, setStatus] = useState('Procurar...');

  const uploadProduto = async (e) => {
    e.preventDefault();

    if (!arquivo) {
      toast.error(`Selecione um arquivo primeiro`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }

    let formData = new FormData();
    formData.append('arquivo', arquivo);
    setEnviando(true);
    const resultado = await api.post('/api/upload/produtos', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (resultado) {
      toast.success(
        `${Number(resultado.data.total).toLocaleString(
          'pt-BR'
        )} produtos cadastrados`,
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        }
      );
      setArquivo(null);
      setStatus('Procurar...');
    }
    setEnviando(false);
  };

  useEffect(() => {
    if (!arquivo) {
      document.getElementById('arquivo').value = null;
    }
  }, [arquivo]);

  return (
    <Container fluid>
      <div>
        <h4 className="pt-3 pb-3 f-black">Upload Produtos Kulzer</h4>
        <hr className="hr-loja mt-0 mb-5" />
      </div>
      <div className="d-flex flex-column align-items-center">
        <form className="form arquivo" onSubmit={uploadProduto}>
          <label htmlFor="codigo">Arquivo .CSV</label>
          <input
            type="file"
            id="arquivo"
            name="arquivo"
            style={{ display: 'none' }}
            onChange={(e) => {
              setArquivo(e.target.files[0]);
              e.target.files.length > 0
                ? setStatus(e.target.files[0].name)
                : setStatus('Procurar...');
            }}
          />
          <input
            id="botao"
            type="button"
            value={status}
            onClick={(e) => {
              document.getElementById('arquivo').click();
            }}
          />
          {enviando ? (
            <button disabled className="btn-primario" type="submit">
              ENVIANDO...
            </button>
          ) : (
            <button className="btn-primario" type="submit">
              ENVIAR
            </button>
          )}
          <button
            className="btn-secundario"
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              historico.push('/painel/processar/produtos');
            }}
          >
            VOLTAR
          </button>
        </form>
      </div>
    </Container>
  );
}
